import fetchGql from '~/utils/fetchGql'
const dayjs = useDayjs()

const query = gql`
  query NavigationheaderItems($startsWith: String) {
    NavigationheaderItems(
      starts_with: $startsWith
      per_page: 1
      resolve_links: "url"
      resolve_relations: "navigation-header.globalAlert"
    ) {
      items {
        content {
          startDate
          endDate
          globalAlert {
            content
          }
          desktopMenuItems
          mobileMenuItems
          logo {
            alt
            filename
          }
        }
      }
    }
  }
`

const parseData = (data: any) => {
  const result: any = {
    alert: null,
    logo: data[0].content.logo,
    desktopMenuItems: [],
    mobileMenuItems: []
  }

  const now = dayjs.utc()
  const startDate = dayjs.utc(data[0].content.startDate)
  const endDate = dayjs.utc(data[0].content.endDate)
  const globalAlert = data[0].content?.globalAlert

  if (now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate)) {
    const alertContent = data[0].content.globalAlert?.content

    if (globalAlert && alertContent?.content) {
      result.alert = {
        isBold: alertContent?.isBold ?? alertContent?.bold,
        closable: alertContent?.closable,
        showDefaultIcon: alertContent?.showDefaultIcon,
        type: alertContent?.type,
        icon: alertContent?.icon,
        content: alertContent?.content
      }
    }
  }

  data[0].content.desktopMenuItems.forEach((menuItem: any) => {
    if (menuItem.items.length > 1) {
      const parsedItems: any[] = []
      menuItem.items.forEach((item: any) => {
        parsedItems.push({
          label: renderRichText(item.text)
            .replace(/^<p>/, '')
            .replace(/<\/p>$/, ''),
          redirect: item.redirect
        })
      })
      result.desktopMenuItems.push({
        title: menuItem.title,
        items: parsedItems
      })
    } else {
      result.desktopMenuItems.push({
        title: menuItem.title,
        redirect: menuItem.items[0].redirect
      })
    }
  })

  data[0].content.mobileMenuItems.forEach((menuItem: any) => {
    if (menuItem.items.length > 1) {
      const parsedItems: any[] = []
      menuItem.items.forEach((item: any) => {
        parsedItems.push({
          label: renderRichText(item.text)
            .replace(/^<p>/, '')
            .replace(/<\/p>$/, ''),
          redirect: item.redirect
        })
      })
      result.mobileMenuItems.push({
        title: menuItem.title,
        items: parsedItems
      })
    } else {
      result.mobileMenuItems.push({
        title: menuItem.title,
        redirect: menuItem.items[0].redirect
      })
    }
  })

  return result
}

export const useFetchHeader = () => {
  const fetchHeader = (language: string) => {
    const variables = {
      startsWith: (language === 'en' ? '' : `${language}/`) + 'careers/data/navigation'
    }

    return fetchGql(query, variables).then((response: any) => {
      return parseData(response.NavigationheaderItems.items)
    })
  }

  return { fetchHeader }
}
